export var version = {
  lib: '2.10112.0',
  product: '2.10112.0',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts